import clx from 'classnames';
import ERROR_ROUTES from 'constants/routes';
import { useTranslation } from 'next-i18next';
import Link, { LinkProps } from 'next/link';
import { MenuItemType } from 'types/cms';

const LegalMenuItem = ({
  item: { key, href, label },
  onClick,
}: {
  item: MenuItemType;
  onClick?: LinkProps['onClick'];
}) => {
  const { t } = useTranslation();

  return (
    <li
      key={key}
      className="md:pr-2 md:border-r-2 md:border-r-white last:mb-4 last:md:mr-auto last:md:mb-0 last:border-r-0"
    >
      <Link
        className={clx('md-medium ')}
        href={href ?? ERROR_ROUTES.NOT_FOUND}
        onClick={onClick}
        suppressHydrationWarning
      >
        {t(label)}
      </Link>
    </li>
  );
};

const LegalMenu = ({ items, cookiePolicy }: { items: MenuItemType[]; cookiePolicy: MenuItemType }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col md:flex-row w-full justify-between px-4 pt-4 border-t border-t-mercury-200 gap-4 max-w-7xl md:m-auto pb-2">
      <ul className="flex gap-2 justify-center">
        {items.map((item) => (
          <LegalMenuItem key={item.key} item={item} />
        ))}

        {cookiePolicy && (
          <LegalMenuItem
            key={cookiePolicy.key}
            item={cookiePolicy}
            onClick={(e) => {
              e.preventDefault();
              window.Didomi?.preferences.show();
            }}
          />
        )}
      </ul>
      <p className="md-bold-caps text-center text-neutral-800 ">{t('all-rights-reserved')}</p>
    </div>
  );
};

export default LegalMenu;
